import {
  ADD_PLAYLIST_REQUEST,
  ADD_PLAYLIST_SUCCESS,
  ADD_PLAYLIST_ERROR,
  ADD_PLAYLIST_DONE,
} from "./actions";

const initialState = {
  requesting: false,
  successful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PLAYLIST_REQUEST:
      return {
        requesting: true,
        successful: false,
      };

    case ADD_PLAYLIST_SUCCESS:
      return {
        requesting: false,
        successful: true,
      };

    case ADD_PLAYLIST_ERROR:
      return {
        requesting: false,
        successful: false,
      };

    case ADD_PLAYLIST_DONE:
      return initialState;

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/playlists/add/reducer.js